import cn from 'classnames'
import React from 'react'
import LazyLoad from 'react-lazy-load'
import { getImage } from '../components/helpers/FormatLinks'
import NewsAndStories from '../components/newestdrops/NewsAndStories'
import CollectionHome from '../components/collectionoverview/CollectionHome'
import Page from '../components/page/Page'
import PreviewCard from '../components/previews/PreviewCard'
import CollectionRankingsHome from '../components/stats/CollectionRankingsHome'
import config from '../config.json'
import { useLanguage, useQueryString } from '../hooks'
import Link from '../components/common/util/input/Link'
import { DropSlider } from '../components/newestdrops/DropSlider'

const HomePage = (props) => {
    const { getValue, values } = useQueryString()
    const { t } = useLanguage(values, 'common')

    const collection = getValue('collection', '')
    const image = getImage(collection)

    const className = cn(
        'p-2 md:p-5 rounded-2xl mx-0 md:mx-3 mb-5 md:mb-0 shadow',
    )

    return (
        <Page
            id={'HomePage'}
            title={config.titles.main}
            description={config.descriptions.main}
            image={image}
            {...props}
        >
            <div className={'mb-4'}>
                <div className={cn('content-center w-full px-2 md:px-10')}>
                    <div
                        className={cn(
                            'block lg:hidden h-full w-full grid grid-cols-3 md:grid-cols-6 lg:mb-10',
                        )}
                    >
                        <PreviewCard
                            title={t('landing.collections_title')}
                            link={'/collections'}
                            background={
                                'bg-gradient-to-bl from-card5 to-card6 hover:shadow-scard6 transition-shadow duration 200'
                            }
                            className={className}
                            backgroundClass={'bg-graphic3'}
                        />
                        <PreviewCard
                            background={
                                'bg-gradient-to-bl from-card1 to-card2 hover:shadow-scard2 transition-shadow duration 200'
                            }
                            title={t('landing.market_title')}
                            link={'/market'}
                            backgroundClass={'bg-graphic2'}
                        />
                        <PreviewCard
                            title={t('landing.bulk_title')}
                            link={'/bulkoverview'}
                            background={
                                'bg-gradient-to-bl from-card3 to-card4 hover:shadow-scard4 transition-shadow duration 200'
                            }
                            className={className}
                            backgroundClass={'bg-graphic1'}
                        />
                        <PreviewCard
                            title={t('navigation.rent_cpu')}
                            link={'/cpu'}
                            background={
                                'bg-gradient-to-bl bg-bottom from-card7 to-card8 hover:shadow-scard8 transition-shadow duration 200'
                            }
                            className={className}
                            backgroundClass={'bg-graphic4'}
                        />
                        <PreviewCard
                            title={t('navigation.drops')}
                            link={'/drops'}
                            background={
                                'bg-gradient-to-bl bg-cover from-card9 to-card10 hover:shadow-scard10 transition-shadow duration 200'
                            }
                            className={className}
                            backgroundClass={'bg-graphic5'}
                        />
                        <PreviewCard
                            title={t('landing.live_listings')}
                            link={'/live'}
                            background={
                                'bg-gradient-to-bl from-card11 to-card12 hover:shadow-scard12 transition-shadow duration 200'
                            }
                            className={className}
                            backgroundClass={'bg-graphic6'}
                        />
                    </div>

                    <div className={cn('w-full mb-10 mt-10 lg:mt-0')}>
                        {process.env.NEXT_PUBLIC_TESTNET === 'TRUE' ? (
                            ''
                        ) : (
                            <CollectionHome />
                        )}
                    </div>
                    <div className={cn('w-full mb-10')}>
                        {process.env.NEXT_PUBLIC_TESTNET === 'TRUE' ? (
                            ''
                        ) : (
                            <DropSlider
                                market={'nfthivedrops'}
                                highlight={false}
                                limit={24}
                                isHome={true}
                                orderBy={'date_desc'}
                                title={t('landing.latest_drops')}
                                href={'/drops'}
                                upcoming={false}
                                prevButtonClass={'latest-drops-prev-button'}
                                prevClassName={'.latest-drops-prev-button'}
                                nextButtonClass={'latest-drops-next-button'}
                                nextClassName={'.latest-drops-next-button'}
                            />
                        )}
                    </div>
                    <div className={cn('w-full mb-10')}>
                        {process.env.NEXT_PUBLIC_TESTNET === 'TRUE' ? (
                            ''
                        ) : (
                            <DropSlider
                                market={'nfthivedrops'}
                                highlight={false}
                                limit={12}
                                isHome={true}
                                orderBy={'date_desc'}
                                title={t('landing.upcoming_drops')}
                                href={'/drops?upcoming=true'}
                                upcoming={true}
                                prevButtonClass="upcoming-drops-prev-button"
                                prevClassName=".upcoming-drops-prev-button"
                                nextButtonClass="upcoming-drops-next-button"
                                nextClassName=".upcoming-drops-next-button"
                            />
                        )}
                    </div>
                    {process.env.NEXT_PUBLIC_TESTNET === 'TRUE' ? (
                        <div
                            className={cn(
                                'font-semibold text-black dark:!text-white text-3xl text-left p-2 lg:p-5 rounded-2xl mx-2 lg:mx-0',
                            )}
                        >
                            {t('landing.welcome_to_nfthive_testnet')}
                            <div className={'font-normal text-base'}>
                                {t('landing.here_you_can_try_creator_tools')}
                            </div>
                            <Link href={'/creator'}>
                                <div
                                    className={
                                        'font-normal text-lg text-primary hover:underline'
                                    }
                                >
                                    {t('navigation.creator')}
                                </div>
                            </Link>
                        </div>
                    ) : (
                        <div className={cn('mb-10')}>
                            <div
                                className={cn(
                                    'font-semibold text-black dark:!text-white text-3xl text-left p-2 lg:py-5 rounded-2xl lg:mx-0',
                                )}
                            >
                                {t('landing.top_performers')}
                            </div>
                            <LazyLoad>
                                <div className={cn('w-full')}>
                                    <CollectionRankingsHome
                                        className={className}
                                        title={t('landing.collections')}
                                    />
                                </div>
                            </LazyLoad>
                        </div>
                    )}
                    <div className={cn('w-full mb-10')}>
                        {process.env.NEXT_PUBLIC_TESTNET === 'TRUE' ? (
                            ''
                        ) : (
                            <NewsAndStories />
                        )}
                    </div>
                </div>
            </div>
        </Page>
    )
}

export default HomePage
